<template>
  <Layout>
    <div>
      <h1>Participation Pass</h1>
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h3>{{ registration.session_title }} Registration Ticket</h3>
            </div>
            <div class="card-body">
              <div class="ticket-info">
                <div class="row">
                  <div class="col-md-6">
                    <div class="info-group">
                      <label><strong>Ticket No:</strong></label>
                      <p>{{ registration.ticket_no }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Name:</strong></label>
                      <p>{{ registration.firstName }} {{ registration.lastName }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Email:</strong></label>
                      <p>{{ registration.email }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Organization:</strong></label>
                      <p>{{ registration.organization }}</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="info-group">
                      <label><strong>Ticket Type:</strong></label>
                      <p>{{ registration.ticket_type }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Registration Date:</strong></label>
                      <p>{{ registration.registrationDate }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Amount Paid:</strong></label>
                      <p class="amount">${{ Number(registration.price).toFixed(2) }}</p>
                    </div>
                    <div class="info-group">
                      <label><strong>Status:</strong></label>
                      <p>
                        <span class="badge" :class="registration.payment_status === 'paid' ? 'badge-success' : 'badge-warning'">
                          {{ registration.payment_status }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="conference-details">
                  <h4>Workshop Details</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <p><strong>Session:</strong> {{ registration.session_title }}</p>
                      <p><strong>Date:</strong>14/11/2025 </p>
                      <!-- <p><strong>Date:</strong> {{ registration.session_day }}</p> -->
                      <!-- <p><strong>Venue:</strong> Singapore Convention & Exhibition Centre</p> -->
                    </div>
                    <div class="col-md-6">
                      <p><strong>Address:</strong>183, Jalan Magazine, George Town, 10300 George Town, Pulau 
                        Pinang, Malaysia</p>
                      <p><strong>Website:</strong> <a>www.acimaging.org</a></p>
                      <p><strong>Contact:</strong> isaci.contact@gmail.com</p>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="included-items">
                  <h4>What's Included</h4>
                  <ul>
                    <li>✓ Full Conference Access (Nov 14 - 16, 2025)</li>
                    <li>✓ Conference Materials and Proceedings</li>
                    <li>✓ Certificate of Attendance</li>
                  </ul>
                </div>
                <hr>
                <div class="important-notes">
                  <h4>Important Notes</h4>
                  <ul>
                    <li>Please bring this ticket and a valid photo ID for check-in</li>
                    <li>Check-in opens at 8:00 AM on Nov 14, 2025</li>
                    <li>Conference materials will be available at the registration desk</li>
                    <li>For dietary requirements, please contact the organizers in advance</li>
                    <li>This ticket is non-transferable and non-refundable</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h4>Quick Actions</h4>
            </div>
            <div class="card-body">
              <!-- <div class="d-grid gap-2">
                <button class="btn btn-primary" @click="downloadTicket">
                  <i class="fa fa-download"></i> Download Ticket
                </button>
                <button class="btn btn-success" @click="printTicket">
                  <i class="fa fa-print"></i> Print Ticket
                </button>
                <button class="btn btn-info" @click="emailTicket">
                  <i class="fa fa-envelope"></i> Email Ticket
                </button>
              </div> -->
              <!-- <hr> -->
              <h5>QR Code</h5>
              <div class="qr-code-container text-center">
                <img :src="handlePhoto(registration.qr_code)" alt="QR Code" style="width: 120px; height: 120px; ">
              </div>
              <hr>
              <h5>Contact Information</h5>
              <p><strong>Email:</strong></p>
              <p>isaci.contact@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'

import {apiService} from '@/config/api'
export default {
  name: 'RegistrationSlip',
  components: {
    Layout
  },
  data() {
    return {
      registration: {
        ticket_no: '',
        firstName: '',
        lastName: '',
        organization: '',
        email: '',
        ticket_type: '',
        registrationDate: '',
        price: '',
        payment_status: '',
        qr_code: '',
        session_title: '',
        session_day: '',
        session_room: ''
      }
    }
  },
  // async mounted() {
  //   const response = await apiService.sessions.getRegistrationInfo()
  //   if (response.data.code === 1 && response.data.data && response.data.data.length > 0) {
  //     const info = response.data.data[0]
  //     this.registration = {
  //       ...info,
  //       registrationDate: this.formatDate(info.createtime)
  //     }
  //   }
  // },
  created() {
    this.getRegistrationInfo()
  },
  methods: {
    // 照片处理
    handlePhoto(photo) {
      if (!photo) return ''
      return  process.env.VUE_APP_BASE_API+photo
    },
    async getRegistrationInfo() {
      const response = await apiService.sessions.getRegistrationInfo()
      if (response.data.code === 1 && response.data.data && response.data.data.length > 0) {
        const info = response.data.data[0]
        this.registration = {
          ...info,
          registrationDate: this.formatDate(info.createtime)
        }
      }
    },
    formatDate(ts) {
      if (!ts || ts === '0000-00-00 00:00:00') return ''
      // 如果是时间戳
      if (!isNaN(ts)) {
        const date = new Date(Number(ts) * 1000)
        return date.toLocaleDateString()
      }
      // 如果是字符串
      return ts.split(' ')[0]
    },
    downloadTicket() {
      // 模拟下载
      const link = document.createElement('a')
      link.href = '#'
      link.download = `AOGS2025_Ticket_${this.registration.ticket_no}.pdf`
      link.click()
      alert('Downloading registration ticket...')
    },
    printTicket() {
      //  window.print()
      // 创建打印内容
      const printContent = this.createPrintContent()
      
      // 创建新窗口用于打印
      const printWindow = window.open('', '_blank')
      printWindow.document.write(printContent)
      printWindow.document.close()
      
      // 等待内容加载完成后打印
      printWindow.onload = function() {
        printWindow.print()
        printWindow.close()
      }
    },
    
    createPrintContent() {
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>ISACI 2025 Registration Ticket</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: Arial, sans-serif;
              font-size: 12px;
              line-height: 1.4;
              color: #333;
              padding: 20px;
            }
            
            .ticket-container {
              max-width: 800px;
              margin: 0 auto;
              border: 2px solid #3498DB;
              border-radius: 8px;
              padding: 20px;
            }
            
            .ticket-header {
              text-align: center;
              border-bottom: 2px solid #3498DB;
              padding-bottom: 15px;
              margin-bottom: 20px;
            }
            
            .ticket-header h3 {
              color: #3498DB;
              font-size: 18px;
              margin-bottom: 5px;
            }
            
            .info-row {
              display: flex;
              margin-bottom: 15px;
            }
            
            .info-group {
              flex: 1;
              margin-right: 20px;
            }
            
            .info-group:last-child {
              margin-right: 0;
            }
            
            .info-group label {
              font-weight: bold;
              color: #666;
              font-size: 11px;
              display: block;
              margin-bottom: 3px;
            }
            
            .info-group p {
              font-size: 12px;
              margin: 0;
            }
            
            .amount {
              font-weight: bold;
              color: #28a745;
              font-size: 14px;
            }
            
            .badge {
              padding: 2px 8px;
              border-radius: 12px;
              font-size: 10px;
              font-weight: bold;
              text-transform: uppercase;
            }
            
            .badge-success {
              background-color: #28a745;
              color: white;
            }
            
            .badge-warning {
              background-color: #ffc107;
              color: #212529;
            }
            
            hr {
              border: none;
              border-top: 1px solid #ddd;
              margin: 15px 0;
            }
            
            .section-title {
              color: #2c3e50;
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            
            .section-content p {
              margin-bottom: 5px;
              font-size: 11px;
            }
            
            .section-content ul {
              padding-left: 15px;
              margin-bottom: 10px;
            }
            
            .section-content li {
              margin-bottom: 3px;
              font-size: 11px;
            }
            
            .section-content a {
              color: #3498DB;
              text-decoration: none;
            }
            
            @page {
              size: A4;
              margin: 1cm;
            }
            
            @media print {
              body {
                padding: 0;
              }
              
              .ticket-container {
                border: none;
                padding: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="ticket-container">
            <div class="ticket-header">
              <h3>ISACI 2025 Conference Registration Ticket</h3>
            </div>
            
            <div class="info-row">
              <div class="info-group">
                <label>Ticket No:</label>
                <p>${this.registration.ticket_no}</p>
              </div>
              <div class="info-group">
                <label>Name:</label>
                <p>${this.registration.firstName} ${this.registration.lastName}</p>
              </div>
              <div class="info-group">
                <label>Email:</label>
                <p>${this.registration.email}</p>
              </div>
              <div class="info-group">
                <label>Organization:</label>
                <p>${this.registration.organization}</p>
              </div>
            </div>
            
            <div class="info-row">
              <div class="info-group">
                <label>Ticket Type:</label>
                <p>${this.registration.ticket_type}</p>
              </div>
              <div class="info-group">
                <label>Registration Date:</label>
                <p>${this.registration.registrationDate}</p>
              </div>
              <div class="info-group">
                <label>Amount Paid:</label>
                <p class="amount">$${Number(this.registration.price).toFixed(2)}</p>
              </div>
              <div class="info-group">
                <label>Status:</label>
                <p>
                  <span class="badge ${this.registration.payment_status === 'paid' ? 'badge-success' : 'badge-warning'}">
                    ${this.registration.payment_status}
                  </span>
                </p>
              </div>
            </div>
            
            <hr>
            
            <div class="section-title">Conference Details</div>
            <div class="section-content">
              <div class="info-row">
                <div class="info-group">
                  <p><strong>Session:</strong> ${this.registration.session_title}</p>
                  <p><strong>Date:</strong> ${this.registration.session_day}</p>
                  <p><strong>Venue:</strong> Singapore Convention & Exhibition Centre</p>
                </div>
                <div class="info-group">
                  <p><strong>Address:</strong> 1 Raffles Boulevard, Singapore 039593</p>
                  <p><strong>Website:</strong> <a href="#">www.aogs2025.org</a></p>
                  <p><strong>Contact:</strong> secretariat@aogs2025.org</p>
                </div>
              </div>
            </div>
            
            <hr>
            
            <div class="section-title">What's Included</div>
            <div class="section-content">
              <ul>
                <li>✓ Full Conference Access (June 15-20, 2025)</li>
                <li>✓ Conference Materials and Proceedings</li>
                <li>✓ Welcome Reception (June 15, 2025)</li>
                <li>✓ Coffee Breaks (Daily)</li>
                <li>✓ Conference Dinner (June 18, 2025)</li>
                <li>✓ Certificate of Attendance</li>
              </ul>
            </div>
            
            <hr>
            
            <div class="section-title">Important Notes</div>
            <div class="section-content">
              <ul>
                <li>Please bring this ticket and a valid photo ID for check-in</li>
                <li>Check-in opens at 8:00 AM on June 15, 2025</li>
                <li>Conference materials will be available at the registration desk</li>
                <li>For dietary requirements, please contact the organizers in advance</li>
                <li>This ticket is non-transferable and non-refundable</li>
              </ul>
            </div>
          </div>
        </body>
        </html>
      `
    },
    emailTicket() {
      const subject = encodeURIComponent('ISACI 2025 Registration Ticket')
      const body = encodeURIComponent(`Dear ${this.registration.firstName} ${this.registration.lastName},\n\nPlease find your registration ticket attached.\n\nTicket No: ${this.registration.ticket_no}\n\nBest regards,\nAOGS 2025 Secretariat`)
      window.open(`mailto:${this.registration.email}?subject=${subject}&body=${body}`)
    },
    addToCalendar() {
      const event = {
        title: 'ISACI 2025 Conference',
        start: '2025-06-15T08:00:00',
        end: '2025-06-20T18:00:00',
        location: 'Singapore Convention & Exhibition Centre',
        description: 'ISACI 22nd Annual Meeting'
      }
      const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${event.start}/${event.end}&details=${encodeURIComponent(event.description)}&location=${encodeURIComponent(event.location)}`
      window.open(calendarUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.info-group {
  margin-bottom: 15px;
}

.info-group label {
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  display: block;
}

.info-group p {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.amount {
  font-weight: bold;
  color: #28a745;
  font-size: 18px;
}

.conference-details h4,
.included-items h4,
.important-notes h4 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.conference-details p,
.included-items li,
.important-notes li {
  margin-bottom: 8px;
  font-size: 14px;
}

.included-items ul,
.important-notes ul {
  padding-left: 20px;
}

.qr-code-placeholder {
  padding: 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  color: #666;
}

.d-grid.gap-2 {
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;

}

@media print {
  .btn {
    /* display: none; */
    display: block !important;
  }
  
  .col-md-4 {
    /* display: none; */
    display: block !important;
  }
  
  .col-md-8 {
    width: 100%;
  }
}
</style> 